<p-table [value]="typesList">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Created By</th>
        <th>Last Modified</th>
        <th>Is Active</th>
        <th>Is Default</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pipe let-i="rowIndex">
      <tr>
        <td>{{pipe.name}}</td>
        <td>{{pipe.createdUser}}</td>
        <td>{{pipe.updatedDate | localDate: 'MM/DD/YYYY'}}</td>
        <td>{{pipe.isActive?answertypeConstants.Yes: answertypeConstants.No}}</td>
        <td class="action">
          <p-radioButton [disabled]="!pipe.isActive" [value]="true" [(ngModel)]="pipe.isDefault"
            (onClick)="eventCalled(pipe)"></p-radioButton>
          {{pipe.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
        </td>
      </tr>
    </ng-template>
</p-table>

 <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>